export { default as FAQ } from './faq';
export { default as FeatureTabsV1 } from './feature-tabs-v1';
export { default as FeatureStepsV1 } from './feature-steps-v1';
export { default as TextAndService } from './text-and-service';
export { default as UnitPackPricing } from './unit-pack-pricing';
export { default as SuggestedFeatures } from './suggested-features';
export { default as FeaturesCategories } from './features-categories';
export { default as PackagePricingPlans } from './package-pricing-plans';
export { default as FeatureServicesTabs } from './feature-services-tabs';
